import { getSectionHeadingPath } from '/src/utils/apiFunctions';
import httpClient from '/src/utils/httpClient';
import { pathTypes } from '/src/utils/sectionEnums';

export function updateMembershipApiCall({
  id,
  isPathDesign,

  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,

  sectionBorderColor,
  sectionIsBackground,
  sectionTextColor,
  sectionBackgroundColor,
  sectionOpacity,
  sectionMargin,
  sectionPadding,
  sectionIsFullWidth,
  sectionShadow,
  sectionShadowColor,
  sectionShadowBorderColor,
  sectionShape,
  sectionBackgroundType,
  sectionBackgroundImage,
  sectionGradientColor1,
  sectionGradientColor2,
  sectionGradientDirection,
  sectionGradientOffset,
  sectionBorder,

  itemShadow,
  itemShadowColor,
  itemShape,
  itemBorder,
  itemBorderColor,
  itemTextColor,
  itemBackgroundColor,

  items,
  view,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.membership, isPathDesign, id), {
    id,
    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,

    sectionBorderColor,
    sectionIsBackground,
    sectionTextColor,
    sectionBackgroundColor,
    sectionOpacity,
    sectionMargin,
    sectionPadding,
    sectionIsFullWidth,
    sectionShadow,
    sectionShadowColor,
    sectionShadowBorderColor,
    sectionShape,
    sectionBackgroundType,
    sectionBackgroundImage,
    sectionGradientColor1,
    sectionGradientColor2,
    sectionGradientDirection,
    sectionGradientOffset,
    sectionBorder,

    itemShadow,
    itemShadowColor,
    itemShape,
    itemBorder,
    itemBorderColor,
    itemTextColor,
    itemBackgroundColor,

    tiers: items,
  });
}
